import { updateContactProfileInputSchema } from '@/entities/client';
import { rejectEmptyPronouns } from '@/shared/lib/reject-empty-pronouns';

export const editContactProfileFormSchema =
    updateContactProfileInputSchema.superRefine(rejectEmptyPronouns);
